import React, { memo } from "react";
import { withStyles } from "@material-ui/core";
import styles from "./styles";
import { TextFieldWithLabel } from "../components/TextField";
import { MAX_LENGTH_CONSTRAINTS } from "../constants";
import FormSectionHeader from "../common/FormSectionHeader";
import RequestorDetails from "../../PickupInfoPopup/components/ReservationRequestorDetails";
import {
  REQUESTOR_API_FIELDS,
  getRequestorFieldError,
  normalizePhoneDigits,
} from "./utils";
import editStopConstants from "../../../DriverPopUp/EditStopDialog/constants";

const PickupRequestorInfo = ({
  requestorInfo,
  requestorErrorInfo,
  updateFormData,
  isReadOnly,
  classes,
}) => {
  const F = REQUESTOR_API_FIELDS;
  const maxText =
    MAX_LENGTH_CONSTRAINTS.CREATE_PICKUP_FORM.RESERVATION_REQUESTOR_TEXT;
  const err = requestorErrorInfo || {};

  const handleChange = (name) => (rawValue) => {
    let value = rawValue;
    if (name === F.PHONE) {
      value = normalizePhoneDigits(rawValue);
    }
    const next = {
      ...requestorInfo,
      [name]: value,
    };
    const requestorErrorInfoNext = {
      ...err,
      [name]: getRequestorFieldError(name, value),
    };
    updateFormData("requestorInfo", next, requestorErrorInfoNext);
  };

  if (isReadOnly) {
    return (
      <div className={classes.readOnlyWrapper}>
        <RequestorDetails data={requestorInfo} />
      </div>
    );
  }

  return (
    <>
      <FormSectionHeader label="Requestor Info (Optional)" />
      <div className={classes.container} id="requestorInfo">
        <TextFieldWithLabel
          label="Name :"
          id={F.NAME}
          handleChange={handleChange(F.NAME)}
          error={err[F.NAME]}
          value={requestorInfo[F.NAME]}
          className={classes.defaultInput}
          containerClass={classes.fieldContainer}
          labelClass={classes.label}
          inputClass={classes.input}
          inputProps={{
            maxLength: maxText,
          }}
        />
        <TextFieldWithLabel
          label="Company :"
          id={F.COMPANY}
          handleChange={handleChange(F.COMPANY)}
          error={err[F.COMPANY]}
          value={requestorInfo[F.COMPANY]}
          labelClass={classes.label}
          inputClass={classes.input}
          containerClass={classes.namefieldContainer}
          className={classes.defaultInput}
          inputProps={{
            maxLength: maxText,
          }}
        />
        <TextFieldWithLabel
          label="Phone :"
          id={F.PHONE}
          handleChange={handleChange(F.PHONE)}
          mask={editStopConstants.PHONE_NUMBER_MASK}
          error={err[F.PHONE]}
          value={requestorInfo[F.PHONE]}
          labelClass={classes.label}
          inputClass={classes.input}
          containerClass={classes.fieldContainer}
          className={classes.defaultInput}
        />
        <TextFieldWithLabel
          label="Email :"
          id={F.EMAIL}
          handleChange={handleChange(F.EMAIL)}
          error={err[F.EMAIL]}
          value={requestorInfo[F.EMAIL]}
          labelClass={classes.label}
          inputClass={classes.input}
          containerClass={classes.fieldContainer}
          className={classes.defaultInput}
          inputProps={{
            maxLength:
              MAX_LENGTH_CONSTRAINTS.CREATE_PICKUP_FORM
                .RESERVATION_REQUESTOR_EMAIL,
          }}
        />
      </div>
    </>
  );
};

export default withStyles(styles)(memo(PickupRequestorInfo));
